<template>
  <div class="table-container">
    <!-- 导航查询模板 -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-button
            icon="el-icon-search"
            plain
            native-type="submit"
            @click="handleQuery"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh-left"
            type="info"
            plain
            native-type="submit"
            @click="resetForm('queryForm')"
          >
            重置
          </el-button>
          <el-button
            icon="el-icon-sort"
            plain
            native-type="submit"
            @click="heightQuery"
          >
            高级筛选
          </el-button>

          <el-form
            ref="queryForm"
            :model="queryForm"
            style="margin-top: 15px"
            class="demo-form-inline my-form-class"
            @submit.native.prevent
          >
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <!-- 下单日期范围  -->
                <el-form-item prop="orderDate">
                  <el-date-picker
                    v-model="queryForm.orderDate"
                    type="daterange"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="下单开始日期"
                    end-placeholder="下单结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item prop="workOrderNo">
                  <el-input
                    v-model.number="queryForm.workOrderNo"
                    placeholder="工单编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 目标主体 -->
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item prop="targetSubject">
                  <el-input
                    v-model.trim="queryForm.targetSubject"
                    placeholder="目标主体"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 项目 -->
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item prop="projectId">
                  <el-cascader
                    :value="queryForm.projectId"
                    :options="projectInfo"
                    clearable
                    :filterable="true"
                    separator=":"
                    placeholder="项目"
                    @change="handleProjectChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="isShow" transiton="fade" :gutter="20">
              <!-- 走访日期范围 -->
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item prop="expectVisitDate">
                  <el-date-picker
                    v-model="queryForm.expectVisitDate"
                    type="daterange"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="走访开始日期"
                    end-placeholder="走访结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <!-- 内部截止日期 -->
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item prop="innerDeadDate">
                  <el-date-picker
                    v-model="queryForm.innerDeadDate"
                    type="daterange"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="内部截止开始日期"
                    end-placeholder="内部截止结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <!-- 质疑状态 -->
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item prop="questionStatus">
                  <el-select
                    v-model="queryForm.questionStatus"
                    placeholder="质疑状态"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in questionStatusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 选择地区 -->
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item prop="address">
                  <el-cascader
                    :value="queryForm.address"
                    :options="cityInfo"
                    :change-on-select="false"
                    :clearable="true"
                    :filterable="true"
                    placeholder="地区"
                    :props="{ checkStrictly: true }"
                    @change="handleBlockChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <!--列表模块-->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-button
            :loading="downloadLoading"
            type="primary"
            @click="handleDownload"
          >
            导出
          </el-button>
          <el-table
            ref="tableSort"
            v-loading="listLoading"
            :data="list"
            :element-loading-text="elementLoadingText"
            style="margin-top: 15px"
            border
            @selection-change="setSelectRows"
          >
            <el-table-column
              type="selection"
              width="40"
              align="center"
            ></el-table-column>
            <el-table-column
              label="工单编号"
              prop="workOrderNo"
              align="center"
              width="130"
            >
              <template slot-scope="scope">
                <img
                  v-if="scope.row.operStatus === 31"
                  src="@/icon/back.svg"
                  alt="退"
                  class="my-back-img"
                />
                {{ scope.row.workOrderNo }}
              </template>
            </el-table-column>
            <el-table-column
              prop="targetSubject"
              label="目标主体"
              width="150"
            ></el-table-column>
            <el-table-column label="目标地址" min-width="250" prop="address">
              <template slot-scope="scope">
                {{ scope.row.address || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="项目" prop="projectName" width="150">
              <template slot-scope="scope">
                {{ scope.row.projectName || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="questionStatusValue"
              label="质疑状态"
              sortable
              width="110"
            >
              <template slot-scope="scope">
                {{ scope.row.questionStatusValue || "-" }}
              </template>
            </el-table-column>
            <!-- 预约走访时间 -->
            <el-table-column
              prop="bookVisitTime"
              label="预约走访时间"
              width="130"
              align="center"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.bookVisitTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="visitTime"
              label="走访时间"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.visitTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="innerDeadline"
              label="内部截止日期"
              sortable
              align="center"
              width="130"
            >
              <template slot-scope="scope">
                {{ scope.row.innerDeadline || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="stepAndStranded"
              align="center"
              width="90"
              label="环节/整体滞留(天)"
              fit="true"
            >
              <template slot-scope="scope">
                {{ scope.row.stepAndStranded || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="70px"
              fixed="right"
              align="center"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="审核"
                  placement="top-start"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-s-check"
                    circle
                    @click="handleReview(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <!--分页模块-->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :background="background"
            :current-page="queryForm.pageNum"
            :layout="layout"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>
    <!--提交工单-->
    <submit ref="submit" @refreshData="refreshData"></submit>

    <!--审核工单-->
    <review
      ref="review"
      @fetchData="fetchData"
      @refreshData="refreshData"
    ></review>
  </div>
</template>

<script>
  import { getTodo } from "@/api/workplace/user/pchUser";
  import submit from "./submit";

  import review from "./review";
  import { returnBitTimestamp, returnDeadtimestamp, getRoleKey } from "@/utils";
  import { mapGetters } from "vuex";
  import {
    getBlock,
    getGeneralReason,
    getProjectSource,
    getRole,
  } from "@/api/workplace/tools";

  export default {
    name: "ComprehensiveTable",
    components: {
      submit,

      review,
    },
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: "success",
          draft: "gray",
          deleted: "danger",
        };
        return statusMap[status];
      },
    },
    data() {
      return {
        transferTitle: ["选择员工", "已选择 1 个，还可以选 0 个"],
        mode: "transfer",
        isShow: false,
        imgShow: true,
        list: [],
        imageList: [],
        listLoading: false,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        background: true,
        selectRows: "",
        elementLoadingText: "正在加载...",
        queryForm: {
          orderDate: null, // 表单数据，不传递到后端
          orderTimeEnd: "",
          orderTimeStart: "",
          workOrderNo: "",
          targetSubject: "",
          projectId: "",

          innerDeadDate: null, // 表单数据，不传递到后端
          innerDeadlineEnd: "",
          innerDeadlineStart: "",
          surveyUser: "",
          address: "",
          reachTime: "",

          normalFallbackFlag: "",
          normalFallbackReasonId: "",

          pageNum: 1,
          pageSize: 10,
          nextUserNo: "",
          nextUserRoleNo: "",
          userNo: "",
          userRoleNo: "",
          expectVisitDate: [], //走访日期
          clockEndTime: null,
          clockStartTime: null,
          preliminaryDate: null,
          firstAuditDateStart: null,
          firstAuditDateEnd: null,
        },
        // 查询用户工作台待办列表参数
        param: {
          body: {},
          header: {
            currentTime: "2020-09-09 12:12:12",
            requestId: "1",
            sourceType: "site",
          },
        },
        // 项目
        projectInfo: [],
        projectForm: {
          body: {
            source: "",
          },
          header: {
            currentTime: "",
            requestId: "123",
            sourceType: "site",
          },
        },
        questionStatusOptions: [
          {
            value: 40,
            label: "待答复",
          },
          {
            value: 41,
            label: "质疑成立",
          },
          {
            value: 42,
            label: "质疑驳回",
          },
        ],
        //   角色人员
        roleOptions: [],
        roleOptions_arr: [],
        roleForm: {
          body: {},
          header: {
            currentTime: "",
            requestId: "123",
            sourceType: "site",
          },
        },

        cityInfo: [],
        cityForm: {
          body: {},
          header: {
            currentTime: "",
            requestId: "123",
            sourceType: "site",
          },
        },

        pickerOptions: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        reasonOptions: [],
        downloadLoading: false,
      };
    },
    computed: {
      ...mapGetters({
        userNo: "user/userNo",
        roles: "user/roles",
      }),
    },
    created() {
      this.queryForm.userNo = this.userNo;
      this.queryForm.userRoleNo = getRoleKey("customer", this.roles);
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
      /** 数据初始化 */
      handleInitData() {
        this.fetchData();
        // 获取项目
        this.getProject();
      },
      /** 导出Excel */
      handleDownload() {
        if (this.selectRows.length > 0) {
          this.downloadLoading = true;
          import("@/vendor/ExportExcel").then((excel) => {
            const tHeader = [
              "工单编号",
              "目标主体",
              "目标地址",
              "项目",
              "质疑状态",
              "预约走访时间",
              "走访时间",
              "内部截止日期",
              "环节/整体滞留(天)",
            ];
            const filterVal = [
              "workOrderNo",
              "targetSubject",
              "address",
              "projectName",
              "questionStatusValue",
              "bookVisitTime",
              "visitTime",
              "innerDeadline",
              "stepAndStranded",
            ];
            const list = this.selectRows;
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: "工单列表",
              autoWidth: true,
              bookType: "xlsx",
            });
            this.downloadLoading = false;
          });
        } else {
          this.$baseMessage("未选中任何行", "error");
          return false;
        }
      },
      /** 组装导出数据 */
      formatJson(filterVal, jsonData) {
        return jsonData.map((v) =>
          filterVal.map((j) => {
            if (!v[j]) {
              return "——";
            }
            return v[j];
          })
        );
      },
      // 刷新数据
      refreshData() {
        /* 添加tab标签  传参 */
        let refresh_data = {
          todo_total: this.total,
          isDone: true,
        };
        this.$emit("child-todo", refresh_data);
        this.fetchData();
      },
      setSelectRows(val) {
        this.selectRows = val;
      },
      // 重置
      resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
          // this.$refs[formName].resetFields();
          this.queryForm = this.$options.data().queryForm;
          this.reset = this.$options.data().reset;
        }
      },

      // 单个提交及批量提交
      handleSubmit(row) {
        // 单个提交
        this.$refs["submit"].showSubmit(row);
      },

      handleReview(row) {
        row.userNo = this.queryForm.userNo;
        row.userRoleNo = this.queryForm.userRoleNo;
        this.$refs["review"].showReview(row);
      },

      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.fetchData();
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.fetchData();
      },
      heightQuery() {
        this.isShow = !this.isShow;
        // 获取角色列表
        this.getRoleList();
        // 获取地区
        this.getAddress();
        // 获取普通退回原因
        this.getNormalReason();
      },
      async getNormalReason() {
        this.reasonOptions = Object.assign(
          {},
          (await getGeneralReason(this.backReasonParam)).body
        );
      },
      //add by peter.wei 20200911
      handleChange(value) {
        this.queryForm.addressProvince = this.queryForm.selectedOptions[0];
        this.queryForm.addressCity = this.queryForm.selectedOptions[1];
        this.queryForm.addressDistrict = this.queryForm.selectedOptions[2];
      },
      handleQuery() {
        this.queryForm.pageNum = 1;
        this.fetchData();
      },
      // 获取用户工作台待办列表分页信息
      async fetchData() {
        this.listLoading = true;
        // 下单日期范围
        if (null !== this.queryForm.orderDate) {
          if (0 < this.queryForm.orderDate.length) {
            this.queryForm.orderTimeStart = returnBitTimestamp(
              this.queryForm.orderDate[0]
            );
            this.queryForm.orderTimeEnd = returnDeadtimestamp(
              this.queryForm.orderDate[1]
            );
          }
        } else {
          this.queryForm.orderTimeStart = null;
          this.queryForm.orderTimeEnd = null;
        }
        // 初审开始日期范围
        if (null !== this.queryForm.preliminaryDate) {
          if (0 < this.queryForm.preliminaryDate.length) {
            this.queryForm.firstAuditDateStart = returnBitTimestamp(
              this.queryForm.preliminaryDate[0]
            );

            this.queryForm.firstAuditDateEnd = returnDeadtimestamp(
              this.queryForm.preliminaryDate[1]
            );
          }
        } else {
          this.queryForm.firstAuditDateStart = null;
          this.queryForm.firstAuditDateEnd = null;
        }
        // 走访截止日期范围
        if (null !== this.queryForm.expectVisitDate) {
          if (0 < this.queryForm.expectVisitDate.length) {
            this.queryForm.clockStartTime = returnBitTimestamp(
              this.queryForm.expectVisitDate[0]
            );
            this.queryForm.clockEndTime = returnDeadtimestamp(
              this.queryForm.expectVisitDate[1]
            );
          }
        } else {
          this.queryForm.clockStartTime = null;
          this.queryForm.clockEndTime = null;
        }
        // 内部截止日期范围
        if (null !== this.queryForm.innerDeadDate) {
          if (0 < this.queryForm.innerDeadDate.length) {
            this.queryForm.innerDeadlineStart = returnBitTimestamp(
              this.queryForm.innerDeadDate[0]
            );

            this.queryForm.innerDeadlineEnd = returnDeadtimestamp(
              this.queryForm.innerDeadDate[1]
            );
          }
        }
        this.queryForm.userNo = this.userNo;
        this.queryForm.userRoleNo = getRoleKey("customer", this.roles);
        this.param.header.currentTime = returnBitTimestamp(new Date());
        this.param.body = Object.assign({}, this.queryForm);
        const { body } = await getTodo(this.param);
        this.list = body.records;
        this.total = body.total;
        let refresh_data = {
          todo_total: this.total,
          isDone: false,
        };
        this.$emit("child-todo", refresh_data);
        this.listLoading = false;
      },

      // 表格显色
      tableRowClassName({ row }) {
        // 到期时间小于3，行内高亮
        if (row.maturityDate <= 3) {
          return "warning-row";
        } else return "";
      },

      // 获取地区
      getAddress() {
        this.cityForm.header.currentTime = returnBitTimestamp(new Date());
        getBlock(this.cityForm).then((response) => {
          if ("1" === response.header.retCode) {
            let block_info = [];
            block_info.push(response.body[0]);
            this.cityInfo = block_info;
          } else {
            this.$message.error(
              `${response.header.retMessage},获取地区失败，请重新刷新页面`
            );
          }
        });
      },
      // 选择地区
      handleBlockChange(value) {
        this.queryForm.address = value.join(",");
      },
      // 获取项目
      getProject() {
        this.projectForm.header.currentTime = returnBitTimestamp(new Date());
        getProjectSource(this.projectForm).then((response) => {
          if ("1" === response.header.retCode) {
            this.projectInfo = response.body;
          }
        });
      },
      // 选择项目
      handleProjectChange(value) {
        if (value) {
          this.queryForm.projectId = value[1];
        }
      },
      getRoleList() {
        let role_arr = [];
        let roleForm = {
          body: [],
          header: {
            currentTime: "",
            requestId: "123",
            sourceType: "site",
          },
        };
        let roleOptions_arr = [];
        // PL人员
        const plUser = [
          {
            roleKey: "PL",
          },
        ];

        // 预约人员
        const bookUser = [
          {
            roleKey: "book_person",
          },
        ];

        // 调查人员
        const surveyUser = [
          {
            roleKey: "full_investigator",
          },
          {
            roleKey: "part_investigator",
          },
        ];

        // 督导人员
        const supervisor = [
          {
            roleKey: "supervisor",
          },
        ];

        // 内审
        const auditUser = [
          {
            roleKey: "verify_people",
          },
        ];

        // 用户
        const pchUser = [
          {
            roleKey: "customer",
          },
        ];

        role_arr.push(
          plUser,
          bookUser,
          surveyUser,
          supervisor,
          auditUser,
          pchUser
        );
        // 异步调用接口，使其按顺序执行
        async function getAsyncRole() {
          roleForm.header.currentTime = returnBitTimestamp(new Date());
          for (let index = 0; index < role_arr.length; index++) {
            roleForm.body = role_arr[index];
            await getRole(roleForm).then((response) => {
              if ("1" === response.header.retCode) {
                roleOptions_arr.push(response.body);
              } else {
                roleOptions_arr.push([]);
              }
            });
            if (index === role_arr.length - 1) {
              return roleOptions_arr;
            }
          }
        }
        getAsyncRole().then((res) => {
          this.roleOptions_arr = res;
        });
      },
      // 获取角色配置项
      getRoleOption(role) {
        switch (role) {
          case "plUser":
            this.roleOptions = this.roleOptions_arr[0];
            break;
          case "bookUser":
            this.roleOptions = this.roleOptions_arr[1];
            break;
          case "surveyUser":
            this.roleOptions = this.roleOptions_arr[2];
            break;
          case "supervisor":
            this.roleOptions = this.roleOptions_arr[3];
            break;
          case "auditUser":
            this.roleOptions = this.roleOptions_arr[4];
            break;
          case "pchUser":
            this.roleOptions = this.roleOptions_arr[5];
            break;
          default:
            break;
        }
      },
    },
  };
</script>
<style scoped>
  .el-col {
    margin-bottom: 10px;
  }
  .el-col :last-child {
    margin-bottom: 0;
  }

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 100%;
  }

  .el-select,
  .el-cascader {
    width: 100%;
  }

  .el-dropdown-menu__item {
    padding: 0;
  }
  .el-table /deep/.warning-row {
    background: #f8b7bc;
  }
  .my-form-class {
    margin-bottom: -10px !important;
  }
</style>
<style>
  .my-back-img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 4px;
    left: 2px;
  }
</style>
